module.exports = "/assets/delice-page/all.jpg?EAZabDv";